export default function serviceCategoriesService($http, RESOURCES) {
  function getServiceCategories() {
    return $http.get(RESOURCES.SERVICE_CATEGORIES);
  }

  return { getServiceCategories: getServiceCategories };
}



// WEBPACK FOOTER //
// ./src/app/merchants/services/service-categories.service.js